import { ImportedDocumentSupportedContentTypes } from '../../shared/modals/fileUploadModal/types';
import { getExtensionByContentType } from '../../../pages/uploadedWebViewer/uploadedViewer/helpers';

export async function downloadPdfHelper(
  fileURL: string,
  fileName: string,
  contentType: ImportedDocumentSupportedContentTypes = 'application/pdf'
) {
  const response = await fetch(fileURL, {
    method: 'GET',
    headers: {
      'Content-Type': contentType,
    },
  });

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status} ${response.statusText}`);
  }

  const blob = await response.blob();
  const extension = getExtensionByContentType(contentType);
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.${extension}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
}
